import React, { useContext, useState, useEffect } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ImgMapbox from '../../Assets/Techs/Mapbox.svg'
import ImgReact from '../../Assets/Techs/React.svg'
import ImgAWS from '../../Assets/Techs/AWS.svg'
import ImgFigma from '../../Assets/Techs/Figma.svg'
import ImgLeaflet from '../../Assets/Techs/Leaflet.svg'
import ImgMUI from '../../Assets/Techs/MUI.svg'
import ImgNode from '../../Assets/Techs/nodeJS.svg'
import ImgExpo from '../../Assets/Techs/Expo.svg'
import ImgJS from '../../Assets/Techs/JS.svg'
import ImgTS from '../../Assets/Techs/TS.svg'
import ImgSwift from '../../Assets/Techs/Swift.svg'
import ImgVscode from '../../Assets/Techs/Vscode.svg'
import ImgXcode from '../../Assets/Techs/Xcode.svg'
import ImgApple from '../../Assets/Techs/Apple.svg'
import { DefaultContext } from '../../Contexts/DefaultContext';
import { ptbr, eng } from '../../Translate';
import './local.css';

function Tecnologies() {
    const { LNG } = useContext(DefaultContext)
    const [larguraTela, setLarguraTela] = useState(window.innerWidth);
    const [changeCar, setChangeCar] = useState(false);
    const settings = {
        dots: true,
        lazyLoad: true,
        infinite: true,
        speed: changeCar ? 1500 : 2000,
        slidesToShow: changeCar ? 3 : 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: true // Se quiser adicionar setas de navegação
    };

    useEffect(() => {
        // Função para atualizar a largura da tela
        const atualizarLarguraTela = () => {
            setLarguraTela(window.innerWidth);
        };

        if (larguraTela <= 600) {
            setChangeCar(false)
        } else {
            setChangeCar(true)
        }

        // Adiciona o event listener para redimensionamento da janela
        window.addEventListener('resize', atualizarLarguraTela);

        // Remove o event listener quando o componente é desmontado
        return () => {
            window.removeEventListener('resize', atualizarLarguraTela);
        };
    }, [larguraTela]);

    return (
        <div id='tecnologies-container'>
            <h1 className="titleTxt exp-title" >{LNG ? ptbr.tecnologies.item_1 : eng.technologies.item_1}</h1>
            <div className="slider-container">
                <Slider {...settings}>
                    <a href="https://www.mapbox.com/" target="_blank" rel="noreferrer">
                        <img src={ImgMapbox} className="img-item" alt="Mapbox" />
                    </a>
                    <a href="https://react.dev/" target="_blank" rel="noreferrer">
                        <img src={ImgReact} className="img-item" alt="React" />
                    </a>
                    <a href="https://docs.amplify.aws/" target="_blank" rel="noreferrer">
                        <img src={ImgAWS} className="img-item" alt="AWS Amplify" />
                    </a>
                    <a href="https://www.figma.com/" target="_blank" rel="noreferrer">
                        <img src={ImgFigma} className="img-item" alt="Figma" />
                    </a>
                    <a href="https://leafletjs.com/" target="_blank" rel="noreferrer">
                        <img src={ImgLeaflet} className="img-item" alt="Leaflet" />
                    </a>
                    <a href="https://mui.com/" target="_blank" rel="noreferrer">
                        <img src={ImgMUI} className="img-item" alt="Material UI" />
                    </a>
                    <a href="https://nodejs.org/" target="_blank" rel="noreferrer">
                        <img src={ImgNode} className="img-item" alt="Node JS" />
                    </a>
                    <a href="https://expo.dev/" target="_blank" rel="noreferrer">
                        <img src={ImgExpo} className="img-item" alt="Expo" />
                    </a>
                    <a href="https://developer.mozilla.org/pt-BR/docs/Web/JavaScript" target="_blank" rel="noreferrer">
                        <img src={ImgJS} className="img-item" alt="JavaScript" />
                    </a>
                    <a href="https://www.typescriptlang.org/" target="_blank" rel="noreferrer">
                        <img src={ImgTS} className="img-item" alt="TypeScript" />
                    </a>
                    <a href="https://www.apple.com/br/swift/" target="_blank" rel="noreferrer">
                        <img src={ImgSwift} className="img-item" alt="Swift" />
                    </a>
                    <a href="https://code.visualstudio.com/" target="_blank" rel="noreferrer">
                        <img src={ImgVscode} className="img-item" alt="VScode" />
                    </a>
                    <a href="https://developer.apple.com/xcode/" target="_blank" rel="noreferrer">
                        <img src={ImgXcode} className="img-item" alt="Xcode" />
                    </a>
                    <a href="https://www.apple.com/br/macos/sonoma/" target="_blank" rel="noreferrer">
                        <img src={ImgApple} className="img-item" alt="MacOS" />
                    </a>
                </Slider>
            </div>
        </div>
    );
}

export default Tecnologies;